import { useCallback } from 'react';

import { useMytaverse } from '@providers/MytaverseProvider';
import { GenderType } from '@features/avaturn/interfaces';
import { env } from 'env';
import { useUserProfileHelperType } from '@features/avaturn/pages/Avaturn/interfaces';

const { REACT_APP_CLIENT_ENV } = env;

const getAvaturnBrand = (): string => {
  return REACT_APP_CLIENT_ENV === 'MYTAVERSE' ? 'no-brand' : '';
};

const useUserProfileHelper: useUserProfileHelperType = () => {
  const { user } = useMytaverse();

  const getProcessedBrand = useCallback(() => getAvaturnBrand(), []);

  const getGender = useCallback(() => {
    if (!user?.gender) {
      return GenderType.MALE;
    }
    return user?.gender?.toLowerCase() === GenderType.FEMALE
      ? GenderType.FEMALE
      : GenderType.MALE;
  }, [user?.gender]);

  return {
    getProcessedBrand,
    getGender,
  };
};

export default useUserProfileHelper;
